import getAllowedFileTypes from '../util/getAllowedFileTypes';
import PropTypes from 'prop-types';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import VizExFileButton from 'visitor-ui-component-library/button/VizExFileButton';
import { jsx as _jsx } from "react/jsx-runtime";
const FilePickerLink = props => {
  return /*#__PURE__*/_jsx(VizExFileButton, {
    accept: getAllowedFileTypes(),
    onClick: props.onClick,
    onChange: props.onChange,
    children: buttonProps =>
    /*#__PURE__*/
    // @ts-expect-error VizExLink onClick is deprecated
    _jsx(VizExLink, Object.assign({
      use: "on-bright"
    }, buttonProps, {
      children: props.children
    }))
  });
};
FilePickerLink.displayName = 'FilePickerLink';
FilePickerLink.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func
};
export default FilePickerLink;